import {
    InfoMailTipExternalRecipients,
    InfoMailTipExternalRecipientsMultiple,
} from '../strings.locstring.json';
import loc, { format } from 'owa-localize';
import {
    MessagePart,
    InfoBarMessageViewState,
    InfoBarMessageRank,
    InfoBarMessageSource,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

import RemoveMultiRecipientMailtip from '../components/RemoveMultiRecipientMailtip';
import * as React from 'react';
import { getMessagePartsForSingleRecipient } from './getGenericMessageParts';
import type MailTipDetails from '../store/schema/MailTipDetails';
import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { MailTipsCategory } from '../datapoints';

/**
 * returns InfoBarMessageViewState for recipients who are external to the organization.
 * returns null if no recipient is external to the organization.
 */
export default (
    recipientInfos: MailTipDetails[],
    onRemoveRecipientsClick?: (recipients: EmailAddressWrapper[]) => void
): InfoBarMessageViewState => {
    if (!recipientInfos.length) {
        return null;
    }
    const messageParts: [string, MessagePart] | null =
        recipientInfos.length === 1 && recipientInfos[0].count === 1
            ? getMessagePartsForSingleRecipient(
                  recipientInfos[0].recipient,
                  loc(InfoMailTipExternalRecipients),
                  onRemoveRecipientsClick,
                  MailTipsCategory.ExternalMemberCount
              )
            : null;

    const recipients = recipientInfos.map(recipientInfo => recipientInfo.recipient);
    const messageElement = !messageParts && (
        <RemoveMultiRecipientMailtip
            messageInfoText={format(loc(InfoMailTipExternalRecipientsMultiple))}
            recipientEmails={recipients}
            onRemove={onRemoveRecipientsClick}
            mailTipsCategory={MailTipsCategory.ExternalMemberCount}
        />
    );
    return {
        key: 'ExternalMemberCount',
        message: messageParts ? messageParts[0] : loc(InfoMailTipExternalRecipientsMultiple),
        messageElement,
        messageParts,
        rank: InfoBarMessageRank.Info,
        source: InfoBarMessageSource.Compose,
    };
};
